import { TableContainer, TablePagination } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { SearchBar } from "components/Common/SearchBar"
import { useAppSelector } from "hooks"
import { type ChangeEvent, useState } from "react"
import type { ILicense } from "types/licenseTypes"
import { LicenseListItemMenu } from "./LicenseListItemMenu"

export function LicenseList() {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searchText, setSeachText] = useState<string>("")

  const currentLicensePool = useAppSelector((state) => state.licensepool.currentLicensePool)
  const licenses = useAppSelector((state) => state.license.licenses)
  const users = useAppSelector((state) => state.users.users)

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filterLicenses = (_value: string, licenses: Array<ILicense>): Array<ILicense> => {
    const licensePoolLicenses = licenses.filter((x) => x.licensePoolId === currentLicensePool?.id)

    const filteredLicenses = licensePoolLicenses.filter((license) => {
      return license.assignedUserId !== null || license.assignedUserId !== ""
    })

    return filteredLicenses
  }

  const getUserName = (userId: string): string => {
    if (userId === null) {
      return "-"
    }

    const user = users.find((x) => x.id === userId)

    if (user) {
      return `${user.firstname} ${user.lastname}`
    }

    return "User Not Found"
  }

  const getLicenseState = (license: ILicense): string => {
    if (license.assignedUserId === null) {
      return "Free"
    }

    if (license.licenseCanceled) {
      return "Canceled"
    }

    return "Active"
  }

  const getCalculatedCancelationDate = (license: ILicense): string => {
    if (!license.licenseCanceled || !currentLicensePool) {
      return "-"
    }

    const releaseDate = new Date(license.cancelationDate)
    const cancelationDate = new Date(releaseDate)
    cancelationDate.setMonth(cancelationDate.getMonth() - currentLicensePool.licenseDuration)

    return cancelationDate.toLocaleDateString()
  }

  return (
    <TableContainer>
      <SearchBar onChange={(value: string) => setSeachText(value)} />
      <div style={{ minHeight: "280px" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Cancelation Date</TableCell>
              <TableCell>Release Date</TableCell>
              <TableCell>Assigned Date</TableCell>
              <TableCell align="right" padding="checkbox"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterLicenses(searchText, licenses)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((license) => (
                <TableRow key={license.id} hover>
                  <TableCell>{getUserName(license.assignedUserId)}</TableCell>
                  <TableCell>{getLicenseState(license)}</TableCell>
                  <TableCell>{getCalculatedCancelationDate(license)}</TableCell>
                  <TableCell>
                    {license.licenseCanceled
                      ? new Date(license.cancelationDate).toLocaleDateString()
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {license.assignedDate
                      ? new Date(license.assignedDate).toLocaleDateString()
                      : "-"}
                  </TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                    <LicenseListItemMenu license={license} />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={filterLicenses(searchText, licenses).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  )
}
